import { z } from 'zod';

const isoDateTime = () => z.string().datetime({ offset: true });

export const jobNoteSchema = z.object({
  id: z.string().uuid(),
  jobId: z.string().uuid(),
  userId: z.string().uuid(),
  message: z.string().min(1),
  createdAt: isoDateTime(),
  updatedAt: isoDateTime(),
});

export const jobNoteInputSchema = z.object({
  jobId: z.string().uuid(),
  message: z.string().min(1),
});

export const jobNoteUpdateSchema = z.object({
  message: z.string().min(1),
});
